/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconShoppingBagCheck = createReactComponent(
  "shopping-bag-check",
  "IconShoppingBagCheck",
  [
    [
      "path",
      {
        d: "M11.5 21h-2.926a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304h11.339a2 2 0 0 1 1.977 2.304l-.5 3.248",
        key: "svg-0"
      }
    ],
    ["path", { d: "M9 11v-5a3 3 0 0 1 6 0v5", key: "svg-1" }],
    ["path", { d: "M15 19l2 2l4 -4", key: "svg-2" }]
  ]
);

export { IconShoppingBagCheck as default };
//# sourceMappingURL=IconShoppingBagCheck.js.map
